import { useState } from "react";
import { isNil } from "lodash-es";
import { BodySmall, Box, Modal, ModalFooter, ModalHeader, Select, SelectChangeEvent } from "@parspec/pixel";

import { useMoveFile } from "src/features/Project/queries";


interface IFolder {
    id: number;
    name: string;
}

const bodySmallSX = { lineHeight: "1.25rem" };

export default function MoveFileModal({
    open,
    onClose,
    onFileMoveSuccess,
    data,
    folders,
}: {
    open: boolean;
    data: { documentId: number; projectId: number };
    onClose: () => void;
    onFileMoveSuccess: () => void;
    folders: IFolder[];
}) {
    const { mutateAsync: moveFile, isLoading: isMovingFile } = useMoveFile();
    const { projectId, documentId } = data;

    const [selectedFolderId, setSelectedFolderId] = useState<number | null>(null);
    const [error, setError] = useState<string | null>(null);

    const onConfirmNewFolder = async () => {
        if (isNil(selectedFolderId)) {
            setError("Required");
            return;
        };

        try {
            await moveFile({
                projectId,
                documentId,
                payload: { new_folder_id: selectedFolderId }
            });
            onFileMoveSuccess();
            onClose();
        } catch (err) { }
    };

    const onChange = (e: SelectChangeEvent) => {
        setSelectedFolderId(Number(e.target.value));
        setError(null);
    };

    const header = <ModalHeader title="Move" onClose={onClose} />
    const footer = (
        <ModalFooter
            onReject={onClose}
            onAccept={onConfirmNewFolder}
            continueButtonLabel="Confirm"
            cancelButtonLabel="Cancel"
            isLoading={isMovingFile}
        />
    );

    return (
        <Modal header={header} footer={footer} open={open} borderRadius="8px">
            <Box width={480} flexDirection="column" display="flex" gap="8px">
                <BodySmall color="text.secondary" sx={bodySmallSX}>
                    Select a folder:
                </BodySmall>
                <Select
                    // If I don't explicitly map this, TS compalains about some issue
                    options={folders.map((folder) => ({
                        label: folder.name,
                        value: folder.id,
                    }))}
                    label="Folder"
                    labelId="move-file-folder-select-label"
                    value={selectedFolderId}
                    onChange={onChange}
                    error={!!error}
                    helperText={error ?? ""}
                    disabled={isMovingFile}
                />
            </Box>
        </Modal>
    );
}